<template>
    <div id="cat" v-cloak>
      <div class="vx-card">
        <div class="vx-card__body card-body">
          <div class="vx-row mb-4">
            <div class="vx-col">
              <vs-button @click="isCreateCountry()" class="bg_l_green" v-has-permission="'CreateCountry'">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
                {{ $t("CreateCountry") }}
              </vs-button>
            </div>
          </div>
          <create-popup
            :show="showCreateCountry"
            @finish="onfinish"
          ></create-popup>
          <modify-popup
            :show="showModifyCountry"
            :CountryForModify="CountryForModify"
            @finish="onfinish"
          ></modify-popup>
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('NameCountry') },
                  { title: $t('Priority') },
                  { title: $t('CreateOn') },
                  { title: $t('Action') }
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 30%">
                    {{ row.name }}
                  </td>
                  <td style="width: 20%">
                    {{ row.priority }}
                  </td>
                  <td style="width: 30%">
                    {{ row.createOn }}
                  </td>

                  <td style="width: 30%">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      v-has-permission="'ModifyCountry'"
                      @click.prevent="isModifyCountry(row)"
                      class="d-inline"
                    ></vs-button>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      v-has-permission="'DeleteCountry'"
                      @click.prevent="isDeleteCountry(row)"
                      class="d-inline mx-4"
                    ></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
  import DataGrid from "@/components/datagrid/DataGrid";
  import CreatePopup from "./CreatePopup.vue";
  import ModifyPopup from "./ModifyPopup.vue";
  
  export default {
    name: "",
    components: {
      CreatePopup,
      ModifyPopup,
      DataGrid
    },
    data() {
      return {
        showCreateCountry: false,
        showModifyCountry: false,
        gridDataSource: {
          type: "app",
          service: "Geography/api/CountriesQuery/countries"
        },
        gridSearchData: {},
        CountryForModify: {}
      };
    },
  
    methods: {
      ...mapActions({
        deleteCountry: "country/remove"
      }),
      isCreateCountry() {
        this.showCreateCountry = true;
      },
      onfinish() {
        this.showCreateCountry = false;
        this.showModifyCountry = false;
        this.$refs.grid.renderGrid();
      },
      isModifyCountry(Country) {
        this.CountryForModify.id = Country.id;
        this.CountryForModify.name = Country.name;
        this.CountryForModify.priority = Country.priority;
        this.showModifyCountry = true;
      },
      isDeleteCountry(Country) {
        this.$swal({
          title: "آیا از حذف این رکورد اطمینان دارید؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بلی",
          cancelButtonText: "خیر"
        }).then(result => {
          if (result.value) {
            this.deleteCountry(Country.id).then(() => {
              this.$refs.grid.renderGrid();
            });
          }
        });
      }
    }
  };
  </script>
  